(function() {
	
	var State = include("springroll.State"),
		Texture = include("PIXI.Texture"),
		Application = include("springroll.Application"),
		Sprite = include("PIXI.Sprite"),
		SuspectClue = include("heist.SuspectClue"),
		Sound = include("springroll.Sound"),
		Tween = include("createjs.Tween"),
		TweenHelper = include("springroll.TweenHelper"),
		AdvancedMovieClip = include("springroll.pixi.AdvancedMovieClip"),
		Animator = include("springroll.pixi.Animator");
	
	var SuspectState = function(options)
	{
		State.call(this, new heist.SuspectPanel(), options);
		
		this.voPlayer = this.app.voPlayer;
		
		this.difficulty = 0;
		this.crimeConfig = null;
		this.criminal = null;
		this.suspects = null;
		this.photos = null;
		this.tacks = null;
		this.clues = null;
		
		this.timeoutTimer = 0;
		this.timeouts = 0;
		this.timeoutTime = this.app.config.game.suspect.timeoutTimer;
		this.wrongAnswers = 0;
		this.timeSinceTimeout = -1;
		
		this.totalTime = 0;
		this.photoHovers = 0;
		this.photoClicks = 0;
		this.clueHovers = 0;
		this.clueClicks = 0;
		
		this.appIsPlaying = false;
		
		this.update = this.update.bind(this);
		this.on("loading", this.onLoading);
		this.on("loaded", this.onLoaded);
	};
	
	// Extend State
	var s = State.prototype;
	var p = SuspectState.prototype = Object.create(s);
	
	var DIFFICULTY = ["easy", "medium", "hard"];
	
	p.onLoading = function(assets)
	{
		s.enter.call(this);
		
		if(this.app.options.difficulty)
			this.difficulty = parseInt(this.app.options.difficulty);
		
		this.wrongAnswers = 0;
		this.timeouts = 0;
		this.timeoutTimer = this.timeoutTime;
		this.totalTime = 0;
		this.photoHovers = 0;
		this.photoClicks = 0;
		this.clueHovers = 0;
		this.clueClicks = 0;
		this.timeSinceTimeout = -1;
		//load up the suspect images and the clues
		this.suspects = [];
		//for debugging, make sure that a letter is selected
		if(DEBUG && !this.app.currentCrimeConfig)
			this.app.selectLetter();
		var crimeConfig = this.crimeConfig = this.app.currentCrimeConfig;
		var suspect = crimeConfig.thief, i;
		var clues = crimeConfig.clues;
		for(i = 0; i < clues.length; ++i)
		{
			suspect += "_" + clues[i].id;
		}
		this.criminal = suspect;
		this.suspects.push(suspect);
		assets.push(this.app.config.assets.suspects[suspect]);
		for(var key in crimeConfig.decoys)
		{
			suspect = key;
			clues = crimeConfig.decoys[key][this.difficulty];
			for(i = 0; i < clues.length; ++i)
			{
				suspect += "_" + clues[i];
			}
			this.suspects.push(suspect);
			assets.push(this.app.config.assets.suspects[suspect]);
		}
		
		//preload sfx, not important that it get loaded before the state enters
		Sound.instance.preload("SFX_PictureAppear");
	};
	
	p.onLoaded = function()
	{
		this.panel.setup();
		
		var config = this.app.config, i;
		
		this.photos = [];
		this.tacks = [];
		this.suspects.shuffle();
		var positions = config.game.suspect.suspectPositions;
		var pinPivot = config.game.suspect.pinPivot;
		for(i = 0; i < this.suspects.length; ++i)
		{
			var position = positions[i];
			var photo = new heist.SuspectPhoto(this, this.suspects[i], position);
			this.panel.levelContainer.addChild(photo);
			this.photos.push(photo);
			var pin = new Sprite(Texture.fromFrame("Tack"));
			pin.pivot.x = pinPivot.x;
			pin.pivot.y = pinPivot.y;
			pin.position.x = position.x;
			pin.position.y = position.y;
			pin.visible = false;
			this.panel.levelContainer.addChild(pin);
			this.tacks.push(pin);
		}
		
		this.clues = [];
		var clues = this.crimeConfig.clues;
		var cluePositions = config.game.suspect.clues;
		for(i = 0; i < clues.length; ++i)
		{
			var clue = new SuspectClue(this, clues[i].id);
			clue.position.x = cluePositions[i].x;
			clue.position.y = cluePositions[i].y;
			this.panel.levelContainer.addChild(clue);
			this.clues.push(clue);
		}
		
		Application.instance.music = "GameLoop";
	};
	
	p.enterDone = function()
	{
		this.appIsPlaying = true;
		
		this.app.trackEvent(["GameBEGIN", "thiefDifficulty_" + DIFFICULTY[this.difficulty]]);
		
		this.app.on("update", this.update);
		
		this.timeoutTimer = this.timeoutTime;
		this.voPlayer.play("Elmo_WhichOne", this.startTweens.bind(this));
	};
	
	p.startTweens = function()
	{
		var suspectConfig = this.app.config.game.suspect;
		var photoTweens = suspectConfig.photoTween;
		var tackTween = suspectConfig.tackTween;
		var i, length, j, tween, tweenList, obj, tweenItem, id;
		
		var playAppearSFX = this.playAppearSFX.bind(this);
		
		var customHandler = function(tween, data, target)
		{
			if(data.audio)
				return tween.call(playAppearSFX);
			return tween;
		};
		
		for(i = 0, length = photoTweens.length; i < length; ++i)
		{
			tweenList = photoTweens[i];
			obj = this.photos[i];
			tween = TweenHelper.build(obj, tweenList, customHandler);
		}
		//on the last photo, enable the photos
		tween.call(this.enableClues.bind(this));
		//also play VO
		tween.call(this.finishInstructions.bind(this));
		//tween in the tacks
		for(i = 0, length = tackTween.length; i < length; ++i)
		{
			tweenList = tackTween[i];
			obj = this.tacks[i];
			tween = TweenHelper.build(obj, tweenList);
		}
	};
	
	p.playAppearSFX = function()
	{
		//play sfx
		Sound.instance.play("SFX_PictureAppear");
	};
	
	p.finishInstructions = function()
	{
		for(var i = 0; i < this.photos.length; ++i)
			this.photos[i].overallHighlight();
		var callback = this.unhighlightPhotos.bind(this);
		this.voPlayer.play("Elmo_ChoosePicture", callback, callback);
	};
	
	p.unhighlightPhotos = function()
	{
		for(var i = 0; i < this.photos.length; ++i)
			this.photos[i].unhighlight();
	};
	
	p.enableClues = function()
	{
		var i;
		for(i = 0; i < this.clues.length; ++i)
			this.clues[i].enable();
		for(i = 0; i < this.photos.length; ++i)
			this.photos[i].enable();
	};
	
	p.update = function(elapsed)
	{
		if(this.timeoutTimer > 0 && !this.voPlayer.playing)
		{
			this.timeoutTimer -= elapsed;
			if(this.timeoutTimer <= 0)
			{
				if(this.timeSinceTimeout < 0)
				{
					this.timeSinceTimeout = 0;
					this.app.trackEvent(["TimeoutPlay",
						"thiefDifficulty_" + DIFFICULTY[this.difficulty]]);
				}
				this.timeoutTimer = this.timeoutTime;
				++this.timeouts;
				if(this.timeouts == 1)
				{
					this.voPlayer.play("Elmo_TO1_LookClosely");
				}
				else if(this.timeouts == 2)
				{
					this.voPlayer.play(this.app.hasTouch ?
													"Elmo_TO2_ChooseTap" : "Elmo_TO2_ChooseClick");
				}
				else if(this.timeouts == 3)
				{
					this.voPlayer.play("Elmo_TO3_FindThreeClues");
				}
				else//4+
				{
					this.voPlayer.play("Elmo_TO4_LookCarefully");
					this.timeouts = 0;
				}
			}
		}
		this.totalTime += elapsed;
		
		if(this.timeSinceTimeout >= 0)
		{
			this.timeSinceTimeout += elapsed;
		}
	};
	
	p.resetTimeouts = function()
	{
		if(this.timeSinceTimeout > 0)
		{
			this.app.trackEvent(["TOReEnage", "thiefDifficulty_" + DIFFICULTY[this.difficulty],
				Math.round(this.timeSinceTimeout)]);
		}
		this.timeSinceTimeout = -1;
	};
	
	p.onSuspectClicked = function(suspectId)
	{
		//see if the instructions were playing.
		if(this.voPlayer.playing && this.voPlayer.voList.indexOf("Elmo_ChoosePicture") > -1)
		{
			this.app.trackEvent(["Skipped",
				"InstructionsThief_" + this.app.totalPlays,
				Math.round(this.voPlayer.getElapsed())]);
		}
		
		this.resetTimeouts();
		
		var i, photo;
		if(suspectId != this.criminal)
		{
			//shake photo
			for(i = 0; i < this.photos.length; ++i)
			{
				photo = this.photos[i];
				if(photo.id == suspectId)
					photo.shake();
			}
			
			Sound.instance.play("SFX_WrongPhoto");
			
			this.timeoutTimer = this.timeoutTime;
			//wrong
			++this.wrongAnswers;
			if(this.wrongAnswers == 1)
			{
				this.voPlayer.play("Elmo_WA1_HmmNo");
			}
			else if(this.wrongAnswers == 2)
			{
				var list = ["Elmo_WA2_WeFound"];
				var clues = this.clues;
				for(i = 0; i < clues.length; ++i)
				{
					var clue = clues[i];
					if(i == 2)
						list.push("Elmo_And", clue.highlight, "Elmo_" + clue.id + "End",
									clue.unhighlight);
					else
						list.push(clue.highlight, "Elmo_" + clue.id, clue.unhighlight);
				}
				list.push("Elmo_WA2_FindSame");
				this.voPlayer.play(list, null, this.unhighlightClues.bind(this));
			}
			else//3+
			{
				for(i = 0; i < this.photos.length; ++i)
				{
					if(this.photos[i].id == this.criminal)
					{
						photo = this.photos[i];
						break;
					}
				}
				this.voPlayer.play(["Elmo_WA3_PT1", photo.blinkHighlight, "Elmo_WA3_PT2"]);
			}
		}
		else
		{
			Sound.instance.play("SFX_CorrectPhoto");
			this.timeoutTimer = 0;
			for(i = 0; i < this.clues.length; ++i)
				this.clues[i].disable();
			//right!
			this.voPlayer.play(["Elmo_CA1_AllSame", "Elmo_CA2_ThiefIs",
				"Elmo_" + this.crimeConfig.thief, "Elmo_CA3_WayToGo"], this.endState.bind(this));
			
			//disable photos and move the wrong ones off screen.
			var config = this.app.config.game.suspect;
			var tweenLists = config.photoDropTweens.slice();
			tweenLists.shuffle();
			var burstData = this.app.getCache("BurstData");
			var burstAtlas = this.app.getCache("SuccessBurst");
			for(i = 0; i < this.photos.length; ++i)
			{
				photo = this.photos[i];
				photo.disable();
				if(photo.id == this.criminal)
				{
					photo.highlight();
					//create star burst anim
					var animList = config.burstAnims;
					this.bursts = [];
					for(var k = 0; k < animList.length; ++k)
					{
						var data = animList[k];
						var burst;
						if(k < 1)
						 	burst = new AdvancedMovieClip(burstData, burstAtlas);
						else
						{
							burst = new AdvancedMovieClip();
							burst.copyFrom(this.bursts[0]);
						}
						this.bursts.push(burst);
						this.panel.levelContainer.addChildAt(burst, 0);
						burst.x = photo.x + data.x;
						burst.y = photo.y + data.y;
						burst.rotation = data.rotation;
						burst.scale.x = burst.scale.y = data.scale;
						this.app.animator.play(burst, "*");
					}
				}
				else
					TweenHelper.build(photo, tweenLists.pop());
			}
		}
	};
	
	p.unhighlightClues = function()
	{
		for(var i = 0; i < this.clues.length; ++i)
			this.clues[i].unhighlight();
	};
	
	p.playVO = function(vo)
	{
		if(this.voPlayer.playing) return false;
		
		this.voPlayer.play(vo);
		this.timeoutTimer = this.timeoutTime;
		this.resetTimeouts();
		return true;
	};
	
	p.endState = function()
	{
		//calculate difficulty for next time around
		if(this.wrongAnswers === 0)
			this.difficulty++;
		else if(this.wrongAnswers >= 2)
			this.difficulty--;
		if(this.difficulty < 0)
			this.difficulty = 0;
		else if(this.difficulty > 2)
			this.difficulty = 2;
		
		//tracking
		this.app.trackEvent(["GameSUCCESS",
			"thiefDifficulty_" + DIFFICULTY[this.difficulty] + "_WA_" + this.wrongAnswers,
			this.wrongAnswers]);
		this.app.trackEvent(["GameSUCCESSInfo_Duration",
			"thiefDifficulty_" + DIFFICULTY[this.difficulty] + "_Duration",
			Math.round(this.totalTime)]);
		this.app.trackEvent(["GameSUCCESSInfo_hover",
			"thiefDifficulty_" + DIFFICULTY[this.difficulty] + "_thiefhovers_" + this.photoHovers +
				"_objecthovers_" + this.clueHovers,
			this.clueHovers + this.photoHovers]);
		this.app.trackEvent(["GameSUCCESSInfo_clicked",
			"thiefDifficulty_" + DIFFICULTY[this.difficulty] + "_thiefclicks_" + this.photoClicks +
				"_objectclicked_" + this.clueClicks,
			this.clueClicks + this.photoClicks]);
			
		this.appIsPlaying = false;
		
		this.app.cutsceneData =
		{
			nextState: "title",
			cutscene: "outro"
		};
		this.manager.state = "cutscene";
	};
	
	p.exitStart = function()
	{
		this.app.off("update", this.update);
		this.voPlayer.stop();
	};
	
	p.exit = function()
	{
		if(this.appIsPlaying)
		{
			this.app.trackEvent(["GameINCOMPLETE",
				"thiefDifficulty_" + DIFFICULTY[this.difficulty] + "_WA_" + this.wrongAnswers,
				this.wrongAnswers]);
			this.app.trackEvent(["Quit", "thiefDifficulty_" + DIFFICULTY[this.difficulty]]);
		}
		
		this.app.unload(this.suspects);
		
		if(!this.clues) return;
		
		this.panel.teardown();
		var i;
		for(i = 0; i < this.photos.length; ++i)
			this.photos[i].destroy();
		for(i = 0; i < this.tacks.length; ++i)
			this.tacks[i].destroy();
		for(i = 0; i < this.clues.length; ++i)
			this.clues[i].destroy();
		for(i = 0; this.bursts && i < this.bursts.length; ++i)
			this.bursts[i].destroy();
		this.photos = this.clues = this.bursts = this.tacks = null;
	};
	
	p.destroy = function()
	{
		s.destroy.call(this);
		
		this.update = null;
	};
	
	namespace('heist').SuspectState = SuspectState;
}());